// extracted by mini-css-extract-plugin
export default {"container":"AreaTab_container__L5yrs"};